export const LEFT_COLUMN_WIDTH = 40;
export const GAP_BETWEEN_COLUMNS = 'md';
